// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"745":"contactDetails","945":"dashboard","966":"login"}[chunkId] + "." + {"745":"47733c74","945":"bdffb7d2","966":"d1572e23"}[chunkId] + ".js";
};